/* eslint-disable import/no-cycle */
import mixpanel from 'mixpanel-browser';
import { getUA } from 'react-device-detect';
import enviroment from '../../enviroment';
import { getDataFromStorage, saveDataToStorage, getClientPlatform } from '../../../../common/config/utils';
import { log, LOG_LEVELS } from '../../../../common/config/app_logger';
import { updateUser, userMPIdentify } from '../../../redux/user/user_action';
import { generateUserProperties } from '../user_properties';
import { mixpanelIgnoreEvents } from '../analytic_const';
import { trackGTMEvent } from './google_tag_manager';

const {
  MP_TOKEN, REPORT_SESSION_BEGAN, SESSION_BEGAN_TIMER
} = enviroment;
let mpConfigured = false;
let sessionBeganTracked = false;
let identifyId = 0;

let sessionBeganEventProps = {};

export const setSessionBeganEventProperties = (props) => {
  sessionBeganEventProps = props;
};

const trackPeopleProperties = () => {
  if (!mpConfigured) return;
  const baseProfileProperties = {
    'last seen platform': getClientPlatform()
  };
  mixpanel.people.set(baseProfileProperties);
};

const trackSuperProperties = () => {
  const props = generateUserProperties();
  log(LOG_LEVELS.DEBUG, 'Mixpanel', 'Base super properties', props);
  mixpanel.register(props);
};

const shouldTrackEvent = (name) => !mixpanelIgnoreEvents.includes(name) && mpConfigured;

export const trackMPEvent = (name, properties) => {
  if (!shouldTrackEvent(name)) return;
  log(LOG_LEVELS.INFO, 'Mixpanel', 'Tracking event', { name, properties });
  log(LOG_LEVELS.DEBUG, 'Mixpanel', 'Event properties', properties);
  trackPeopleProperties();
  trackSuperProperties();
  mixpanel.track(name, properties);
};

export const updateLastHit = () => {
  if  (!mpConfigured || !sessionBeganTracked) return;
  saveDataToStorage('LAST_HIT', new Date());
};

const ignoreBySessionParamLogic = () => {
  if (REPORT_SESSION_BEGAN === 'none') return true;
  if (REPORT_SESSION_BEGAN === 'user' && !window.currentUserId) return true;
  if (REPORT_SESSION_BEGAN === 'attributed' && window.attribution.mixpanel.media_status === 'Organic') return true;
  return false;
};

const ignoreTrackSessionBeganEvent = (lastHit, lastHitSec) => {
  if (getUA.includes('HeadlessChrome')) return true;
  if (lastHit && lastHitSec / 60 < parseInt(SESSION_BEGAN_TIMER, 10)) return true;
  return ignoreBySessionParamLogic();
};

const trackSessionBeganEvent = () => {
  sessionBeganTracked = true;
  const lastHit = getDataFromStorage('LAST_HIT');
  const lastHitSec = (new Date() - new Date(lastHit)) / 1000;
  if (ignoreTrackSessionBeganEvent(lastHit, lastHitSec)) return;
  const sessionCount = parseInt(getDataFromStorage('BROWSER_SESSIONS'), 10) || 0;
  const props = {
    'sessions count': sessionCount,
    'time from last session': parseInt(lastHitSec, 10),
    ...sessionBeganEventProps
  };
  trackMPEvent('session began', props);
  trackGTMEvent('session began', props);
  saveDataToStorage('BROWSER_SESSIONS', sessionCount + 1);
  updateLastHit();
};

const addMPAttributions = () => {
  if (window.attribution && window.attribution.mixpanel) {
    mixpanel.register(window.attribution.mixpanel);
  }
};

export const mixpanelReset = () => {
  identifyId = 0;
  mixpanel.reset();
};

const resetMPIfNeed = () => {
  if (!window.currentUserId && mixpanel.get_property('user id')) mixpanelReset();
};

export const mixpanelInit = () =>  {
  if (mpConfigured) return;
  mixpanel.init(MP_TOKEN, { loaded: resetMPIfNeed });
  addMPAttributions();
  mpConfigured = true;
  log(LOG_LEVELS.INFO, 'Mixpanel', 'Configuration complete');
  if (!window.currentUserId) {
    trackSessionBeganEvent();
  }
};

const registerUser = (id) => {
  if (!mpConfigured) return;
  identifyId = id;
  mixpanel.alias(id);
};

const identify = (id) => {
  identifyId = id;
  mixpanel.identify(id);
};

export const mixpanleIdentifyUser = () => (dispatch, getState) => {
  const { user: { userId, userMixpanelAliasCreated }  } = getState().user;
  if (!mpConfigured || userId === identifyId) return;
  if (userMixpanelAliasCreated) {
    log(LOG_LEVELS.INFO, 'Mixpanel', `Identifying user: ${ userId }`);
    identify(userId);
    dispatch(userMPIdentify());
    trackSessionBeganEvent();
    return;
  }
  log(LOG_LEVELS.INFO, 'Mixpanel', `Registering user: ${ userId }`);
  registerUser(userId);
  dispatch(updateUser({ mixpanelAliasCreated: true }));
  dispatch(userMPIdentify());
};
